import { render, staticRenderFns } from "./revocationPlatformDialog.vue?vue&type=template&id=a56312a4&"
import script from "./revocationPlatformDialog.vue?vue&type=script&lang=js&"
export * from "./revocationPlatformDialog.vue?vue&type=script&lang=js&"
import style0 from "./revocationPlatformDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports